import React from 'react'
import BannerCustom from '../../../../../components/Banners/BannerCustom'

const BalanceErrorBanner = ({ error }) => {
	if (!error) {
		return null
	}

	return (
		<>
			<BannerCustom
				status={'critical'}
				message={error}
			/>
			<br />
		</>
	)
}

export default BalanceErrorBanner

